import { atom } from 'recoil';
import { SubscriptionPlan } from 'utils/mapping/mapSubscriptionPlan';
export const selectedSubscriptionPlan = atom({
  key: 'selectedSubscriptionPlan',
  default: SubscriptionPlan.Standard // Default to Standard
});
export const isSubscriptionPlanFormValid = atom({
  key: 'isSubscriptionPlanFormValid',
  default: true // Always valid since we always have a selection
});